export default __webpack_public_path__ + "static/media/control-button-back-to-lobby.312abbe1.png";